
import React, {useState,Fragment} from "react";
import "./Modal.css";
// import Modal from '@material-ui/core/Modal';

const Modal =  React.memo(props => (
    <React.Fragment>
    {props.show &&
    <div className="modal-open">
    <div className={"fade modal-backdrop "+(props.show ? "show" : "")}> </div>
    <div id="modmodal" role="dialog" aria-modal="true" className={"modModal fade modal  "+(props.show ? "show" : "")} tabIndex="-1" >
      <div role="document" className="modal-dialog">
            <div  className="modal-content">
                <div className="modal-body">
                {props.isSucc ?   <div>הודעתך נשלחה בהצלחה</div>    
               :  props.Text.length > 1 ? <div>{props.Text}</div> :
               ( <div><div>אירעה שגיאה במערכת</div><div> אנא נסה שוב במועד מאוחר יותר</div> </div>)
                } 
            <button onClick={props.onClose} className="btn btn-secondary">OK</button> 
                </div>
            </div>
        </div>
    </div>
    </div>}
   </React.Fragment>     
));
    
  
    export default Modal;